import { memo, useMemo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import TitledTextArea from "@coworker/apprestructured/src/task-management/components/TitledTextArea/TitledTextArea";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

const MAX_TEXT_AREA_LENGTH = 1000;

function TitledTextAreaViewerFragmentDemo() {
  const [value, setValue] = useState("Example resolution text");

  const error = useMemo(() => {
    if (value.length > MAX_TEXT_AREA_LENGTH) {
      return `Maximum ${MAX_TEXT_AREA_LENGTH} characters`;
    }
    return null;
  }, [value]);

  return (
    <Demo>
      <Name>TitledTextAreaViewerFragment</Name>
      <Highlight>
        <TitledTextArea
          title="resolutionString"
          label="resolutionString"
          value={value}
          onChange={setValue}
          error={error}
        />
      </Highlight>
    </Demo>
  );
}

export default memo(TitledTextAreaViewerFragmentDemo);
